// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditProfileForm_wrapper__nD1Pb","contacts":"EditProfileForm_contacts__3T2m0","select":"EditProfileForm_select__j-0QU"};